module.exports = __webpack_public_path__ + "img/findSessionsNoData.14475fef.svg";